import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MainLoadingService } from '../services/main-loading.service';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../../../auth/auth.service';
import { Router } from '@angular/router';
import { ProfileService } from '../../../private/profile/profile.service';
import { environment } from '@env/env';

interface SubMenuItem {
  description: string;
  route: string;
}

interface MenuItem {
  title: string;
  icon: string;
  roles: string[];
  route?: string;
  subMenus?: SubMenuItem[];
}
interface Company {
  name: string;
  cnpj: string;
  type?: string;
}

interface Profile {
  companyRelationsWithCompanyId: Company[];
  id: string;
  cpf: string;
  fullName: string;
  email: string;
  password: string;
  birthdate: string;
  postalCode: string;
  streetAddress: string;
  neighborhood: string;
  city: string;
  state: string;
  additionalDetails: string;
  number: string;
  createdBy: string;
  disabled: boolean;
  keycloakId: string;
  keycloakRoles: string;
  dataSharedCompanies: any[];
  company: Company;
  cellphone: string;
}

@Component({
  selector: 'app-authenticated-layout',
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
})
export class AuthenticatedLayoutComponent implements OnInit {
  mainLoading: boolean = false;
  panelOpenState: boolean = false;
  menu: MenuItem[] = [];
  nameUser: string = '';
  roles: string[] = [];
  profileData?: Profile;
  isDevelopment = environment.development;
  isHomolog = environment.homolog;
  isProduction = environment.production;

  constructor(
    private mainLoadingService: MainLoadingService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private router: Router,
    private _profileService: ProfileService
  ) {
    this.getUserInformation();
    this.generateMenu();
  }

  ngOnInit(): void {
    this.mainLoadingService.loading.subscribe((loading) => {
      this.mainLoading = loading;
      this.cdr.detectChanges();
    });
  }

  getUserInformation() {
    this.roles = this.authService.getRolesFromToken() ?? [''];
    this.nameUser = this.authService.getUsernameFromToken() ?? '';

    this._profileService.getUserByKeycloakId().subscribe({
      next: (resp: any) => {
        this.profileData = resp;
      }, error: (resp: any) => {
        console.error(resp);
      }
    });
  }

  private generateMenu() {
    this.menu = [
      // {
      //   title: 'Cadastros',
      //   icon: 'groups',
      //   roles: ['sysadmin'],
      //   subMenus: [
      //     {
      //       description: 'Operadoras',
      //       route: '/private/operadoras',
      //     },
      //   ],
      // },
      {
        title: 'Dashboard',
        icon: 'dashboard',
        route: '/private/dashboard',
        roles: ['default', 'sysadmin', 'operator-admin', 'operator-base', 'client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        // Item próprio, e não subMenu do Dashboard: o template só aplica hasRole() em
        // item sem subMenus (`*ngIf="!item.subMenus && hasRole(item.roles)"`), então
        // virando grupo a apuração apareceria para cliente e só seria barrada depois,
        // pelo guard da rota.
        title: 'Apuração',
        icon: 'request_quote',
        route: '/private/dashboard/apuracao-faturamento',
        roles: ['institution-base', 'institution-admin'],
      },
      {
        title: 'Clientes',
        icon: 'group',
        route: '/private/clientes',
        roles: ['operator-admin', 'sysadmin', 'operator-base', 'client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Transações',
        icon: 'shopping_cart',
        route: '/private/transactions-v2',
        roles: ['client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Extratos',
        icon: 'receipt_long',
        route: '/private/extratos',
        roles: ['client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Favorecidos',
        icon: 'contacts',
        route: '/private/favorecidos',
        roles: ['client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Transferências',
        icon: 'swap_horiz',
        route: '/private/transferencias',
        roles: ['client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Saldos',
        icon: 'account_balance_wallet',
        route: '/private/saldos',
        roles: ['client-base', 'client-admin', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Operadoras',
        icon: 'apartment',
        route: '/private/operadoras',
        roles: ['sysadmin', 'operator-admin', 'operator-base', 'client-admin', 'client-base', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Usuários',
        icon: 'person',
        route: '/private/usuarios',
        roles: ['sysadmin', 'operator-admin', 'operator-base', 'client-admin', 'client-base', 'institution-base', 'institution-admin'],
      },
      {
        title: 'Configuração da Instituição',
        icon: 'account_balance',
        route: '/private/configuracao-instituicao',
        roles: ['sysadmin', 'operator-admin', 'operator-base'],
      },

      // {
      //   title: 'Extrato',
      //   icon: 'receipt_long',
      //   route: '/private/extratos',
      //   roles: ['client-base', 'client-admin', 'institution-base', 'institution-admin'],
      // },
    ];
  }

  hasRole(itemRoles: string[]): boolean {
    return itemRoles.some((role) => this.roles.includes(role));
  }

  goToPage(route: string, sidenav: MatSidenav): void {
    this.router.navigate([route]);
    sidenav.close();
  }

  logout(): void {
    this.authService.logout();
  }

  setMainLoading(loading: boolean): void {
    this.mainLoading = loading;
  }

  goToProfile(): void {
    this.router.navigate([`/private/profile`]);
  }

  redirectDashboard(): void {
    this.router.navigate([`/private/dashboard`]);
  }
}
